import ListItem, {ListItemProps} from "@mui/material/ListItem"
import React from "react"
import {Link, LinkProps} from "react-router-dom"

export const ListItemLink = (props: ListItemProps & LinkProps) => (
    <ListItem component={Link} {...props}/>
)
